import { createElement, useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { useProfileStore } from "@store/profile"; // enable in OOP2

import {
  getTabPath,
  getVisibleSettingsTabs,
  isTabPathActive,
} from "./tabsUtils";
import type { SettingsTabItem } from "@octopus-settings/types";

const useTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const isOrgAdmin = useProfileStore((state) => Boolean(state.user?.organisation_role?.role === "org_admin")); // enable in OOP2
  const visibleTabs = useMemo(() => getVisibleSettingsTabs(), []);

  const activeTabIndex = useMemo(() => {
    const index = visibleTabs.findIndex((tab) =>
      isTabPathActive(location.pathname, tab),
    );
    return index === -1 ? 0 : index;
  }, [location.pathname, visibleTabs]);

  const tabItems = useMemo<SettingsTabItem[]>(
    () =>
      visibleTabs.map((tab) => ({
        label: tab.label,
        testId: tab.testId,
        icon: createElement(tab.icon),
      })),
    [visibleTabs],
  );

  const handleTabChange = useCallback(
    (nextTabIndex: number) => {
      const nextTab = visibleTabs[nextTabIndex];
      if (!nextTab) {
        return;
      }
      const targetPath = getTabPath(nextTab);
      if (location.pathname === targetPath) {
        return;
      }
      navigate(targetPath);
    },
    [location.pathname, navigate, visibleTabs],
  );

  return {
    activeTabIndex,
    handleTabChange,
    tabItems,
  };
};

export default useTabs;
